document.documentElement.classList.remove('no-js');

(function () {
  var activeGallery = null;
  var activeIndex = 0;

  function getImages(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('[data-product-thumb]')).map(function (thumb) {
      return {
        src: thumb.getAttribute('data-full-src'),
        alt: thumb.getAttribute('data-alt') || '',
        thumb: thumb
      };
    });
  }

  function setMainImage(gallery, index) {
    var images = getImages(gallery);
    var selected = images[index];
    if (!selected) return;

    var mainImage = gallery.querySelector('[data-main-product-image]');
    var mainButton = gallery.querySelector('[data-open-lightbox]');
    if (mainImage) {
      mainImage.src = selected.src;
      mainImage.alt = selected.alt;
    }
    if (mainButton) mainButton.setAttribute('data-lightbox-index', index);

    images.forEach(function (item) { item.thumb.classList.remove('is-active'); });
    selected.thumb.classList.add('is-active');
  }

  function renderLightbox() {
    if (!activeGallery) return;
    var images = getImages(activeGallery);
    var selected = images[activeIndex];
    if (!selected) return;

    var lightbox = activeGallery.querySelector('[data-product-lightbox]');
    var lightboxImage = activeGallery.querySelector('[data-lightbox-image]');
    if (!lightbox || !lightboxImage) return;

    lightboxImage.src = selected.src;
    lightboxImage.alt = selected.alt;
    setMainImage(activeGallery, activeIndex);
  }

  function openLightbox(gallery, index) {
    activeGallery = gallery;
    activeIndex = Number(index) || 0;
    var lightbox = gallery.querySelector('[data-product-lightbox]');
    if (!lightbox) return;
    renderLightbox();
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('lightbox-open');
  }

  function closeLightbox() {
    if (!activeGallery) return;
    var lightbox = activeGallery.querySelector('[data-product-lightbox]');
    if (lightbox) {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('lightbox-open');
  }

  function moveLightbox(direction) {
    if (!activeGallery) return;
    var images = getImages(activeGallery);
    if (!images.length) return;
    activeIndex = (activeIndex + direction + images.length) % images.length;
    renderLightbox();
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-product-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-product-gallery]');
      setMainImage(gallery, Number(thumb.getAttribute('data-lightbox-index')) || 0);
      return;
    }

    var opener = event.target.closest('[data-open-lightbox]');
    if (opener) {
      openLightbox(opener.closest('[data-product-gallery]'), opener.getAttribute('data-lightbox-index'));
      return;
    }

    if (event.target.closest('[data-lightbox-close]')) closeLightbox();
    if (event.target.closest('[data-lightbox-prev]')) moveLightbox(-1);
    if (event.target.closest('[data-lightbox-next]')) moveLightbox(1);
    if (event.target.matches('[data-lightbox-stage]')) closeLightbox();
  });

  document.addEventListener('keydown', function (event) {
    if (!document.body.classList.contains('lightbox-open')) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') moveLightbox(-1);
    if (event.key === 'ArrowRight') moveLightbox(1);
  });
})();
